import { __assign, __read } from "tslib";
import { findIndex } from 'lodash-es';
import update from 'immutability-helper';
import * as actionTypes from '../constants/actionTypes';
import { isGIF } from '../utils/image';
import isBrowserInFullScreenMode from '../utils/isBrowserInFullScreenMode';
export var initialState = {
    scrollPos: {
        current: null,
        previous: null,
    },
    scrollTo: null,
    scrollingToAnnotation: null,
    smoothScroll: false,
    // TODO just reference project.screens
    screenSequence: [],
    currentScreen: null,
    resetGIF: null,
    // We need to know about the last screen so we can animate it away correctly
    previousScreen: null,
    transition: null,
    backTransition: null,
    isTransitionComplete: {
        previous: true,
        current: false,
    },
    renderedDimensions: null,
    showScreenInfo: false,
    // TODO move to comment reducer
    commentCount: 0,
    // Overlays
    // We can't split to a separate reducer as we
    // need to know about the current screen
    // TODO  better solution might be to move all LOCATION_CHANGED
    // handlers into the location reducer?
    // We use the hotspot ID not the overlay ID so we can position and
    // animate the overlay correctly when deep linked
    currentOverlayHotspot: {
        id: null,
        animate: true,
        screenScrollPos: null,
        positionParent: null,
    },
    // We need to know about the last overlay so we can animate it away correctly
    previousOverlayHotspot: {
        id: null,
        animate: false,
        screenScrollPos: null,
        positionParent: null,
    },
};
export default function screen(state, action) {
    var _a, _b, _c, _d;
    if (state === void 0) { state = initialState; }
    if (action.type === actionTypes.SET_INITIAL_SCREEN) {
        return update(state, { currentScreen: { $set: { id: action.screenID } } });
    }
    if (action.type === actionTypes.LOCATION_CHANGED) {
        var screenID = action.screenID, hotspotID = action.hotspotID, showScreens = action.showScreens, sectionID = action.sectionID;
        if (showScreens) {
            // Don't blow away any state if showing the grid view. In the scenario
            // where someone:
            //
            //   1. opens the grid
            //   2. navigates back
            //   3. navigates forward (reopnes the grid view)
            //   4. closes the grid view
            //
            // then we'll still have the state to show the correct screen
            return state;
        }
        var screenStateChanges = {
            sectionID: { $set: sectionID },
        };
        var isNavigatingBack = false;
        var transition = void 0;
        var backTransition = void 0;
        if (screenID !== (state.currentScreen && state.currentScreen.id)) {
            var screenTransition = action.screenTransition;
            var currentScreen = null;
            if (screenID) {
                currentScreen = getScreenByID(state.screenSequence, screenID);
            }
            isNavigatingBack = isBackNavigation(state, screenID);
            if (!isNavigatingBack) {
                transition = screenTransition;
                backTransition = screenTransition;
            }
            else {
                transition = state.backTransition;
                backTransition = screenTransition;
            }
            if (isInitialPageLoad(state)) {
                screenTransition = null;
            }
            screenStateChanges = __assign(__assign({}, screenStateChanges), { currentScreen: { $set: currentScreen }, previousScreen: { $set: state.currentScreen }, transition: { $set: transition }, backTransition: { $set: backTransition }, isTransitionReversed: { $set: isNavigatingBack }, isTransitionComplete: {
                    current: { $set: false },
                    previous: { $set: !transition },
                } });
            if (currentScreen && currentScreen.img && isGIF(currentScreen.img.url)) {
                screenStateChanges.resetGIF = { $set: currentScreen.img.url };
            }
        }
        var overlayTransition = action.overlayTransition;
        if (isHidingOverlay(state, screenID, hotspotID)) {
            return update(state, __assign(__assign({}, screenStateChanges), updateHotspotID(state, hotspotID, {
                animatePrevious: true,
                animateCurrent: !isNavigatingBack,
                previousTransition: overlayTransition,
            })));
        }
        // Showing overlay
        var animateCurrent = !isNavigatingBack || overlayTransition;
        return update(state, __assign(__assign({}, screenStateChanges), updateHotspotID(state, hotspotID, {
            animatePrevious: false,
            animateCurrent: animateCurrent,
            currentTransition: overlayTransition,
        })));
        // TODO changing overlay!
    }
    if (action.type === actionTypes.LOAD_FULL_PROJECT_DONE ||
        action.type === actionTypes.SET_PROJECT) {
        var _e = action.project, screens = _e.screens, hotspotMap = _e.hotspotMap, groupedScreens = _e.groupedScreens;
        var currentScreen = state.currentScreen;
        if (isBrowserInFullScreenMode()) {
            _a = __read(screens, 1), currentScreen = _a[0];
        }
        else if (currentScreen && currentScreen.id) {
            currentScreen = getScreenByID(screens, currentScreen.id);
        }
        else if (state.sectionID) {
            var section = groupedScreens.find(function (_a) {
                var id = _a.id;
                return id === state.sectionID;
            });
            _b = __read(section.screens, 1), currentScreen = _b[0];
        }
        else {
            _c = __read(screens, 1), currentScreen = _c[0];
        }
        return update(state, {
            // TODO no need to copy this here, just access on state.project
            screenSequence: { $set: screens },
            hotspotMap: { $set: hotspotMap },
            // ////////////////////////////////////////////////////////////
            currentScreen: { $set: currentScreen },
            overScreen: { $set: currentScreen },
        });
    }
    if (action.type === actionTypes.SHOW_SCREEN ||
        action.type === actionTypes.SHOW_HOVER_SCREEN) {
        var screenID = action.screenID, transition = action.transition, scrollPos = action.scrollPos;
        var screenIndex_1 = getScreenIndex(state.screenSequence, screenID);
        return updateStateToAdjacentScreen(state, function () { return screenIndex_1; }, transition, scrollPos);
    }
    if (action.type === actionTypes.SCREEN_RESIZED) {
        return update(state, {
            renderedDimensions: { $set: action.renderedScreenDimensions },
            currentOverlayHotspot: { screenScrollPos: { $set: null } },
        });
    }
    if (action.type === actionTypes.SCROLL_TO) {
        var position = action.position, smoothScroll = action.smoothScroll;
        return update(state, {
            scrollTo: { $set: position },
            smoothScroll: { $set: smoothScroll },
        });
    }
    if (action.type === actionTypes.UNSET_SCROLL_POS) {
        return update(state, {
            scrollPos: { current: { $set: null } },
            scrollTo: { $set: null },
            smoothScroll: { $set: false },
        });
    }
    if (action.type === actionTypes.SCREEN_TRANSITION_COMPLETED) {
        var whichScreen = action.isCurrent ? 'current' : 'previous';
        var change = {
            isTransitionComplete: (_d = {}, _d[whichScreen] = { $set: true }, _d),
        };
        return update(state, change);
    }
    if (action.type === actionTypes.SHOW_SCREEN_INFO) {
        return update(state, {
            showScreenInfo: { $set: true },
        });
    }
    if (action.type === actionTypes.HIDE_SCREEN_INFO) {
        return update(state, {
            showScreenInfo: { $set: false },
        });
    }
    if (action.type === actionTypes.SHOW_OVERLAY ||
        action.type === actionTypes.SHOW_HOVER_OVERLAY) {
        var hotspotID = action.hotspotID, overridePosition = action.position;
        return update(state, updateHotspotID(state, hotspotID, {
            animatePrevious: false,
            overridePosition: overridePosition,
        }));
    }
    if (action.type === actionTypes.HIDE_OVERLAY) {
        var hotspotID = null;
        var transition = action.transition;
        return update(state, updateHotspotID(state, hotspotID, {
            animatePrevious: true,
            previousTransition: transition,
        }));
    }
    if (action.type === actionTypes.GIF_RESET_DONE) {
        return update(state, {
            resetGIF: { $set: null },
        });
    }
    return state;
}
function updateStateToAdjacentScreen(state, moveFunc, transition, scrollPos) {
    if (scrollPos === void 0) { scrollPos = { current: 0, previous: null }; }
    var isTransitionReversed = transition && transition.indexOf('-reversed') !== -1;
    if (isTransitionReversed) {
        // eslint-disable-next-line no-param-reassign
        transition = transition.replace('-reversed', '');
    }
    var hotspotID = null;
    var noOfScreens = state.screenSequence.length;
    var currentScreenIndex = getScreenIndex(state.screenSequence, state.currentScreen.id);
    var nextScreenIndex = moveFunc(currentScreenIndex, noOfScreens);
    var nextScreen = state.screenSequence[nextScreenIndex];
    if (state.currentScreen.id === nextScreen.id) {
        return update(state, updateHotspotID(state, hotspotID, { animatePrevious: false }));
    }
    var changes = __assign({ currentScreen: { $set: nextScreen }, overScreen: { $set: nextScreen }, previousScreen: { $set: state.currentScreen }, underScreen: { $set: state.currentScreen }, transition: { $set: transition }, backTransition: { $set: transition }, isTransitionComplete: { $set: { current: false, previous: !transition } }, isTransitionReversed: { $set: isTransitionReversed } }, updateHotspotID(state, hotspotID, { animatePrevious: false }));
    if (isGIF(nextScreen.img.url)) {
        changes.resetGIF = { $set: nextScreen.img.url };
    }
    if (scrollPos) {
        changes.scrollPos = { $set: scrollPos };
    }
    return update(state, changes);
}
function updateHotspotID(state, hotspotID, _a) {
    var _b = _a.animateCurrent, animateCurrent = _b === void 0 ? true : _b, animatePrevious = _a.animatePrevious, previousTransition = _a.previousTransition, currentTransition = _a.currentTransition, overridePosition = _a.overridePosition;
    // When navigating back with navigation buttons, the reducer
    // will try to `updateHotspotID` on LOCATION_CHANGE, setting
    // `previousOverlayHotspot` to be the same as `currentOverlayHotspot`.
    // This is incorrect and hence we should make sure that `hotspotID`
    // is not equal `state.currentOverlayHotspot.id` before updating
    // First time this runs, both `state.currentOverlayHotspot.id` and
    // `hotspotID` will be null
    if (!state.currentOverlayHotspot.id ||
        hotspotID !== state.currentOverlayHotspot.id) {
        return {
            currentOverlayHotspot: {
                $set: {
                    id: hotspotID,
                    animate: animateCurrent,
                    transition: currentTransition,
                    screenScrollPos: null,
                    positionParent: hotspotID ? state.currentOverlayHotspot.id : null,
                    overridePosition: overridePosition,
                },
            },
            previousOverlayHotspot: {
                $set: {
                    id: state.currentOverlayHotspot.id,
                    screenScrollPos: state.currentOverlayHotspot.screenScrollPos,
                    positionParent: state.currentOverlayHotspot.positionParent,
                    animate: animatePrevious,
                    transition: previousTransition,
                    overridePosition: state.currentOverlayHotspot.overridePosition,
                },
            },
        };
    }
    return {};
}
function isInitialPageLoad(_a) {
    var previousScreen = _a.previousScreen;
    return !previousScreen;
}
function isHidingOverlay(state, screenID, hotspotID) {
    return (state.currentOverlayHotspot.id &&
        !hotspotID &&
        state.currentScreen.id === screenID);
}
function isBackNavigation(state, destinationScreenID) {
    if (!state.isTransitionReversed) {
        return (state.previousScreen && state.previousScreen.id === destinationScreenID);
    }
    return (state.previousScreen && state.previousScreen.id !== destinationScreenID);
}
// TODO move to selector
export function getScreenByID(screens, screenID) {
    if (!screens.length) {
        return {
            id: screenID,
        };
    }
    return screens[getScreenIndex(screens, screenID)] || screens[0];
}
// TODO move to selectors/screen or utils or ...?
export function getScreenIndex(screens, screenID) {
    return findIndex(screens, function (s) { return s.id === screenID; });
}
